<div class="layout" [ngClass]="containerClass">
  <igx-topbar
    [menu]="menu()"
    [hideSideBar]="hideSideBar()"
    [languages]="languages()"
    [currentLanguage]="currentLanguage()"
    (languageChange)="languageChange.emit($event)"
  ></igx-topbar>

  @if (!hideSideBar()) {
    <igx-sidebar [menu]="menu()"></igx-sidebar>
  }

  <main class="layout__main-container">
    <div class="layout__main">
      <router-outlet></router-outlet>
      <p-toast position="bottom-right" />
    </div>
  </main>
  <div class="layout-mask animate-fadein"></div>
</div>
